import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Modal } from 'react-bootstrap';
import PlaylistSharedForm from './PlaylistSharedForm.jsx';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { updatePlaylist } from '../../../actions/collection';
import SocialMediaButtons from '../../common/SocialMediaButtons.jsx';


const PlaylistsSharedModal = ({id, name, shared, shared_link, updatePlaylist}) => {
  let [show, setShow] = useState(false);
  const [sharedState, setSharedState] = useState(shared);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeShared = (value) => {
    setSharedState(value);
    updatePlaylist(id, {'shared': value});
  }

  return(
  <>
     <Dropdown.Item as="button" onClick={ handleShow }>
       { gettext('Поделиться') }
     </Dropdown.Item>

    <Modal show={ show } onHide={ handleClose } size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>
          { gettext('Поделиться плейлистом') }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PlaylistSharedForm shared={ sharedState }
                            shared_link={ shared_link }
                            id={ id }
                            onChangeShared={ handleChangeShared }/>
        { sharedState && <SocialMediaButtons name={ name }
                                             link={ shared_link }
                                             title={ gettext('мой плейлист гитарной музыки') }/> }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ handleClose }>
          { gettext('Закрыть') }
        </Button>
      </Modal.Footer>
    </Modal>
  </>
  )
}

PlaylistsSharedModal.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  shared: PropTypes.bool.isRequired,
  shared_link: PropTypes.string.isRequired,
  updatePlaylist: PropTypes.func.isRequired,
}

export default compose(
  connect(null, { updatePlaylist }),
)(PlaylistsSharedModal);


